import { Head } from "@inertiajs/react";
import { Theme } from "@radix-ui/themes";
import { type ReactNode } from "react";

export default function MarketingLayout({ children }: { children: ReactNode }) {
  return (
    <Theme appearance="light">
      <Head>
        <link
          href="https://fonts.googleapis.com/css2?family=Oswald:wght@400;500;600;700&family=Barlow:wght@400;500;600&display=swap"
          rel="stylesheet"
        />
      </Head>
      <div className="bg-[#0b0b0b] text-[#f0ece8] min-h-screen overflow-x-hidden">
        {children}
      </div>
    </Theme>
  );
}
